const defaultTitle = 'Angeplus';

export const PAGE_TITLE = {
  defaultTitle,
};
